import st from "@/styles/Banks.module.scss"
import DashboardWideComponent from "@/components/DashboardWideComponent.tsx";
import {useState} from "react";
import clsx from "clsx";
import CMS from "@/utils/cms.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {useTranslation} from "react-i18next";
import CommonClass from "@/utils/common.ts";
import {useNavigate, useParams} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import useLoans from "@/hooks/loans.ts";
// import DividerSimple from "@/ui/DividerSimple.tsx";
// import {penalty_amount} from "@/utils/constants.ts";
import Images from "@/utils/images.ts";
import {loansReqs} from "@/services/loans.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";


const Banks = () => {

    const {urn, all} = useParams()
    const loans = useLoans()
    const all_banks = CMS.banks.repeater
    const online_payment = CMS.online_payment.repeater
    const e_payments = CMS.e_payments.repeater
    const stores = CMS.stores.repeater

    const all_payment_methods = [...all_banks, ...online_payment, ...e_payments, ...stores ]

    const [selected_bank, set_selected_bank] = useState(all_payment_methods[0].label)
    const { i18n} = useTranslation()
    const navigate = useNavigate()
    const dc = DashboardClass
    const {t} = useTranslation()


    const credit = ():LoanInterface | undefined => {
        if(!urn) return undefined
        return loans.getLoanByContract(urn as string)
    }



    return (
        <DashboardWideComponent
            hidden_back

            heading={"Mobile Banking"}

            onBackClick={() => {navigate(-1)}}

            header_content={credit() ? (

                <div className={st.header_content}>

                    {(() => {
                        const amn = credit()?.inst_amount

                        return (
                            <>
                                <div className={clsx(st.row, st.total)}>
                                    <span className={st.gray}>
                                        {t("to_pay")}
                                    </span>
                                    {/*@ts-ignore*/}
                                    <span className={clsx(st.black, credit()?.loan_age > 0 && st.danger)}>
                                        {`${all === "1" ? CommonClass.formatMoneyAmount(Number( credit()?.disc_amount)) : CommonClass.formatMoneyAmount(Number(amn))} ${t("currency")}`}
                                    </span>
                                </div>
                            </>
                        )
                    })()}

                </div>

            ) : <></>}

            column_center={
                <div className={st.column_center}>

                    <div className={st.right}>
                        <div className={st.methods_block_container}>

                            <div className={st.methods_block}>
                                <span className={st.pament_method_span}>{t("bank_payment")}</span>

                                <PaymentsList
                                    payments={all_banks}
                                    all={all}
                                    credit={credit()}
                                    selected_bank={selected_bank}
                                    set_selected_bank={(i) => {
                                        set_selected_bank(i)
                                    }}
                                />

                            </div>

                            <div className={st.methods_block}>
                                <span className={st.pament_method_span}>{t("online_payment")}</span>

                                <PaymentsList
                                    payments={online_payment}
                                    all={all}
                                    credit={credit()}
                                    selected_bank={selected_bank}
                                    set_selected_bank={(i) => {
                                        set_selected_bank(i)
                                    }}
                                />

                            </div>

                            <div className={st.methods_block}>
                                <span className={st.pament_method_span}>{t("real_payment")}</span>

                                <PaymentsList
                                    payments={e_payments}
                                    all={all}
                                    credit={credit()}
                                    selected_bank={selected_bank}
                                    set_selected_bank={(i) => {
                                        set_selected_bank(i)
                                    }}
                                />

                            </div>

                            <div className={st.methods_block}>
                                <span className={st.pament_method_span}>{t("stores_payment")}</span>

                                <PaymentsList
                                    payments={stores}
                                    all={all}
                                    credit={credit()}
                                    selected_bank={selected_bank}
                                    set_selected_bank={(i) => {
                                        set_selected_bank(i)
                                    }}
                                />

                            </div>

                            <div className={st.methods_block}>
                                <span className={st.pament_method_span}>{t("office_payment")}</span>

                                <div
                                    className={clsx(
                                        st.bank_item,
                                    )}
                                    onClick={() => {
                                        navigate(dc.dashboard_routes.Locations)
                                    }}
                                >
                                    <div className={st.img_container}>
                                        <img src={Images.logos.TextlessLogo} alt="bank"/>
                                    </div>

                                    <span>{t("offices")}</span>
                                </div>
                            </div>

                        </div>

                    </div>

                    {(() => {
                        let bank = all_payment_methods.find((x) => x.label === selected_bank)
                        const instr = CMS.langAwareFilter(bank, (i18n.language as LocalLanguage)).instructions
                        return (
                            <div
                                className={st.instructions}
                                dangerouslySetInnerHTML={{__html: instr}}
                            />
                        );
                    })()}
                </div>
            }
        />
    )
}

interface Props {
    payments: Array<any>
    credit: LoanInterface | undefined
    selected_bank: any

    set_selected_bank(i: any): void

    all:any
}

const PaymentsList:React.FC<Props> = (props) => {

    const {
        payments,
        credit,
        selected_bank,
        set_selected_bank,
        all
    } = props

    const dc = DashboardClass
    const navigate = useNavigate()
    const {i18n, t} = useTranslation()

    const getPaymentType = (label: string) => {
        switch (label) {
            case "oplata": return "standard"
            case "mia": return "mia"
            default: return "standard"
        }
    }

    const handlePayment = async (val: string) => {
        const payload = {
            payment_method: val,
            language: i18n.language as LocalLanguage,
            urn: credit?.urn || "",
            ...(val === "standard" && {payment_option: all || 0}),
            ...(val === "mia" && all === "1" && {amount: credit?.disc_amount})
        }

        const response = await loansReqs().oplata_pay(payload);

        if (response.status === 200) {
            // Create a Blob and URL
            const blob = new Blob([response.response], { type: "text/html" });
            const url = URL.createObjectURL(blob)

            // Open in a new tab
            window.open(url, "_blank");
        } else {
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar,"error", t("error_message"))
        }
    }

    return (
        <div className={st.payments_list}>
            {(Array.isArray(payments) && payments.length) ? payments.map((obj: any, i: number) => {

                const data = CMS.langAwareFilter(obj, (i18n.language as LocalLanguage))
                const {name, label_image, label} = data

                return (
                    <div
                        key={`bank_${i}`}
                        className={clsx(
                            st.bank_item,
                            label === selected_bank && st.selected
                        )}
                        onClick={() => {
                            if (obj["function"]) {
                                handlePayment(getPaymentType(label))
                            } else {
                                if (window.innerWidth > CommonClass.breakpoints.breakpoint2) {
                                    set_selected_bank(label)
                                } else {
                                    navigate(dc.dashboard_routes.Bank + "/" + i)
                                }
                            }
                        }}
                    >
                        <div className={st.img_container}>
                            <img src={CMS.getFilePath(label_image[0].path)} alt="bank"/>
                        </div>

                        <span>{name}</span>
                    </div>
                )
            }) : null}
        </div>
    )
}

export default Banks